import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SelectOption from './select_option.js';
import Utils from './utils.js';

class FormSelect extends Component {
  onChange(event) {
    this.props.onChange(event.target.value);
  }

  render() {
    const self = this;
    const { blankText = 'Select...'} = this.props;
    let includeBlank = false;
    if (this.props.includeBlank) {
      includeBlank = this.props.includeBlank;
    }
    return (
      <select
        className={Utils.classStyle(this.props, 'form-control')}
        name={this.props.name}
        value={this.props.value}
        ref="select"
        disabled={this.props.isDisabled}
        onChange={this.onChange.bind(this)}
        style={{...this.props.style}}
      >
        {includeBlank ? (
          <SelectOption key="" value="" data={blankText} />
        ) : null}
        {this.props.options.map((option) => {
          const data = self.props.capitalize ? Utils.capitalize(option[0]) : option[0];
          return <SelectOption key={option[1] || option[0]} value={option[1] || option[0]} data={data} />;
        })}
      </select>
    );
  }
}

FormSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  includeBlank: PropTypes.bool,
  options: PropTypes.array.isRequired,
  classStyle: PropTypes.string,
  blankText: PropTypes.string,
  capitalize: PropTypes.bool,
};

FormSelect.defaultProps = {
  capitalize: false,
};

export default FormSelect;